<mat-toolbar color="primary" class="mat-elevation-z8">
 <ng-container *ngIf="isLog">
     <fa-icon [icon]="faBars" (click)="onToggleSidenav()"></fa-icon>
      <span class="main_title">
        {{title}}
      </span>
      <app-user-menu [user]="user" (toggleDrawer)="onToggleSidenav($event)"></app-user-menu>
 </ng-container>
</mat-toolbar>